
@if (!useSummaryView) {
    @if (!field.hidden) {
        <div class="flex flex-col w-full" animate.enter="fade-in">
            <div>
                @if (!field.browserOpts.inLineWithCaption) {
                    <mat-label *ngIf="">{{ field.label | localize }}</mat-label>
                }
                <div>
                    @for (val of emojisValue; track val) {
                        <button class="mx-2" mat-icon-button (click)="markEmoji(val)">
                            @if (val.emoji === 'S') {
                                @if (!val.marked) {
                                    <mat-icon class="text-red-600 scale-[2]" svgIcon="emoji-sad-outline"></mat-icon>
                                } @else {
                                    <mat-icon class="text-red-600 scale-[2]" svgIcon="emoji-sad-solid"></mat-icon>
                                }
                            } @else if (val.emoji === 'H') {
                                @if (!val.marked) {
                                    <mat-icon class="text-green-500 scale-[2]" svgIcon="emoji-happy-outline"></mat-icon>
                                } @else {
                                    <mat-icon class="text-green-500 scale-[2]" svgIcon="emoji-happy-solid"></mat-icon>
                                }
                            } @else if (val.emoji === 'N') {
                                @if (!val.marked) {
                                    <mat-icon class="text-amber-500 scale-[2]" svgIcon="emoji-none-outline"></mat-icon>
                                } @else {
                                    <mat-icon class="text-amber-500 scale-[2]" svgIcon="emoji-none-solid"></mat-icon>
                                }
                            }
                        </button>
                    }
                </div>
                @if (field.control.errors) {
                    @if (field.control.hasError('incorrect')) {
                        <div class="text-sm text-warn leading-none font-medium mt-2">
                            {{ 'errorRequiredField' | transloco }}
                        </div>
                    }
                }
            </div>
        </div>
    }
} @else {
    @for (val of emojisValue; track val) {
        <button mat-icon-button (click)="markEmoji(val)">
            @if (val.emoji === 'S') {
                @if (!val.marked) {
                    <mat-icon svgIcon="emoji-sad-outline"></mat-icon>
                } @else {
                    <mat-icon svgIcon="emoji-sad-solid" color="danger"></mat-icon>
                }
            } @else if (val.emoji === 'H') {
                @if (!val.marked) {
                    <mat-icon svgIcon="emoji-happy-outline"></mat-icon>
                } @else {
                    <mat-icon svgIcon="emoji-happy-solid"></mat-icon>
                }
            } @else if (val.emoji === 'N') {
                @if (!val.marked) {
                    <mat-icon svgIcon="emoji-none-outline"></mat-icon>
                } @else {
                    <mat-icon svgIcon="emoji-none-solid"></mat-icon>
                }
            }
        </button>
    }
}